export default __webpack_public_path__ + "static/team-member-3-642db60be14c9d9d4d03c4c14e2334b1.png";